import {styled, Paper, Grid, TextField, MenuItem, IconButton} from "@mui/material";
import {useMemo} from "react";
import {useFormik} from "formik";
import useCategories from "../../hooks/useCategories";
import SearchIcon from "@material-ui/icons/Search";
import {isNotEmpty} from "../../shared/functions/types_check";

const Container = styled(Paper)({
    margin: '0 auto',
    padding: 5,
    display: 'flex',
    alignItems: 'center',
    width: 600,
})

export default function ItemSearchCategory({onSearch}) {
    const {categories} = useCategories();

    const formik = useFormik({
        initialValues: {
            _categoryId: '',
            _subCategoryId: ''
        }
    })

    const {
        values,
        errors,
        touched,
        getFieldProps,
        setFieldValue,
    } = formik;

    const subCategories = useMemo(() => {
        const {_categoryId: mainId} = values;
        const exist = categories.find(one => one.id === mainId);

        if (!exist) return [];

        return exist?.children || [];

    }, [values, categories]);

    const handleMainCategoryChange = change => {
        setFieldValue('_categoryId', change);
        setFieldValue('_subCategoryId', '');
    };

    const handleSearch = () => {
        const {_categoryId, _subCategoryId} = values

        let Categorie = null;

        if (isNotEmpty(_categoryId)) {
            const {id, label, children} = categories.find(one => one.id === _categoryId);

            Categorie = {
                Id: id,
                Label: label
            };

            if (isNotEmpty(_subCategoryId)) {
                const {id, label} = children?.find(one => one.id === _subCategoryId);

                Categorie = {
                    ...Categorie,
                    SubCategorie: {
                        Id: id,
                        Label: label
                    }
                };

            }

        }
        onSearch(Categorie)
    }

    return (
        <Container>
            <Grid container justifyContent={'space-between'}>
                <Grid item md={5} xs={12}>
                    <TextField
                        fullWidth
                        select
                        size={'small'}
                        label='Category'
                        variant={'outlined'}
                        error={Boolean(touched._categoryId && errors._categoryId)}
                        helperText={touched._categoryId && errors._categoryId}
                        {...getFieldProps('_categoryId')}
                        onChange={({target: {value}}) => handleMainCategoryChange(value)}
                    >

                        <MenuItem value=''>
                            <em>None</em>
                        </MenuItem>

                        {
                            categories.map(({id, label}) => (
                                <MenuItem value={id} key={id}>
                                    {label}
                                </MenuItem>
                            ))
                        }

                    </TextField>
                </Grid>
                <Grid item md={5} xs={12}>
                    <TextField
                        fullWidth
                        select
                        size={'small'}

                        label='Sub Category'
                        variant={'outlined'}
                        error={Boolean(touched._subCategoryId && errors._subCategoryId)}
                        helperText={touched._subCategoryId && errors._subCategoryId}
                        {...getFieldProps('_subCategoryId')}
                    >

                        <MenuItem value=''>
                            <em>None</em>
                        </MenuItem>


                        {
                            subCategories.map(({id, label}) => (
                                <MenuItem value={id} key={id}>
                                    {label}
                                </MenuItem>
                            ))
                        }

                    </TextField>
                </Grid>
                <Grid item xs={1} >
                    <IconButton onClick={handleSearch}>
                        <SearchIcon/>
                    </IconButton>
                </Grid>
            </Grid>
        </Container>
    )
}